module.exports = __webpack_public_path__ + "82e32cd703122a1900f62adbf688b556.jpeg";


//////////////////
// WEBPACK FOOTER
// ./pages/news/12/Andreas_Boman_Mathem.jpeg
// module id = 237
// module chunks = 0